<template>
  <div class="section-container">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="section-container-spacer text-center">
            <h1 class="h2">05 : 联系我们</h1>
          </div>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <h3>地址</h3>
                  <p>四川·成都·高新区 天府大道吉瑞三路99号 <br/> 泰然环球时代中心 C座1704</p>
                  <h3>Phone</h3>
                  <p>028-86038336</p>
                  <h3>Email</h3>
                  <p>contact@rollong.com</p>
                </div>
                <div class="col-xs-12 col-md-6">
                  <a href="https://map.baidu.com/poi/%E6%88%90%E9%83%BD%E8%AF%BA%E6%9C%97%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@11585367.379999995,3554010.817285171,17z/maptype%3DB_EARTH_MAP?uid=4d694f15dca59118102935f1&primaryUid=7492083689233626089&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
                      target="_blank" class="black-image-project-hover">
                    <img src="../assets/images/address-2.png" class="img-responsive" alt=""/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      noWarn: true,
    }
  },
  watch: {},
  methods: {},
  mounted() {},
}
</script>
<style lang="scss">
</style>